export default "__VITE_ASSET__C2ZZQMfk__"